module.exports = __webpack_public_path__ + "static/parade-2020-house25-d04ac03bb520dde3e067ef864900db82.jpg";